import db from "@/components/firebaseInit";
import firebase from "firebase/compat/app";
import axios from "axios";
import moment from "moment";
import { appConfig } from "@/components/toLoad/appConfig";
import { cssGlobal } from "@/components/toLoad/cssGlobal";
import { listUtils } from "@/components/toLoad/listUtils";
import { fieldsRules } from "@/components/toLoad/fieldsRules";
import { models } from "@/components/toLoad/models";
import { functions } from "@/components/toLoad/functions";
import { tableHeaders } from "@/components/toLoad/tableHeaders";
import { ai } from "@/components/toLoad/ai";
import { katana } from "@/components/toLoad/katana";
import { katanaApi } from "@/components/toLoad/api";
import { watch as watchLive } from "@/components/toLoad/live";

export const appGlobals = {
  $db: db,
  $firebase: firebase,
  $moment: moment,
  $axios: axios,
  $appConfig: appConfig,
  $cssGlobal: cssGlobal,
  $listUtils: listUtils,
  $fieldsRules: fieldsRules,
  $models: models,
  $functions: functions,
  $tableHeaders: tableHeaders,
  $ai: ai,
  $katana: katana,
  $api: katanaApi,
  $live: { watch: watchLive },
  $performance: true,
};

export function installAppGlobals(Vue) {
  Object.keys(appGlobals).forEach((key) => {
    Vue.prototype[key] = appGlobals[key];
  });
}
